/**
 * Formatage de dates deterministe.
 *
 * `toLocaleDateString` depend de l'ICU de l'environnement : Node et le
 * navigateur ne produisent pas la meme chaine (espaces insecables, casse du
 * mois, ordre). Au pre-rendu, l'ecart devient une erreur d'hydratation React
 * (#418) et le texte servi a Google differe de celui affiche.
 *
 * Ces fonctions rendent exactement la meme chaine partout.
 */

const MOIS = [
  'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
];

const MOIS_COURTS = [
  'janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin',
  'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.',
];

function parse(value: string | Date): Date | null {
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** « 10 août 2026 ». Chaine vide si la date est invalide. */
export function formatDateLong(value: string | Date): string {
  const d = parse(value);
  if (!d) return '';
  return `${d.getUTCDate()} ${MOIS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** « 10 août ». Pour les listes compactes. */
export function formatDateShort(value: string | Date): string {
  const d = parse(value);
  if (!d) return '';
  return `${d.getUTCDate()} ${MOIS_COURTS[d.getUTCMonth()]}`;
}

/** « 2026-08-10 ». Format numerique stable. */
export function formatDateNumeric(value: string | Date): string {
  const d = parse(value);
  if (!d) return '';
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${d.getUTCFullYear()}-${mm}-${dd}`;
}
